import React from "react";
//#region types
import { FormFieldProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import useDebounceInput from "../hooks/useDebounceInput";
import ReadOnlyField from "../baseFields/readOnlyField";
import SimpleTimePicker from "../../datePickers/simpleTimePicker";
import usePlaceholder from "../hooks/usePlaceholder";
import { FormControl } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function TimePickerFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const {
    name,
    field,
    errors,
    value,
    handleOnChangeCustom,
    handleOnBlurCustom,
    success,
    invertedDisplayType,
    optional,
    readonly,
  } = props;

  const hasError = !!errors;

  const { internalValue, debouncedHandleOnChangeCustom } = useDebounceInput({
    name: name,
    value: value,
    handleOnChangeCustom: handleOnChangeCustom,
  });

  const placeholder = usePlaceholder(field.label, field.placeholder, optional);

  return readonly ? (
    <ReadOnlyField label={field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {value}
    </ReadOnlyField>
  ) : (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <SimpleTimePicker
        disabled={props.disabled}
        label={LocalizationHelperInstance.getFormattedMessage(field.label)}
        overridePlaceholder={placeholder}
        value={internalValue ?? null}
        error={hasError}
        name={name}
        onChange={debouncedHandleOnChangeCustom.bind(null, name)}
        onBlur={handleOnBlurCustom.bind(null, name)}
        success={success}
        displayType={invertedDisplayType}
        className={field.classes?.input}
      />
    </FormControl>
  );
}

export default TimePickerFormField;
